module.exports = __webpack_public_path__ + "media/images/freejob_banner_pc-4bdf3c64f2ee67ef19dc346769b540cd.png";